import { MyCompanyFragment } from '@Graphql/graphqlTypes.generated';

export const checkMissingPhone = (companies: MyCompanyFragment[] | undefined) =>
  !!companies?.find(c => c.isActive && !c.company.phone) || false;
